import { Injectable } from "@angular/core";
import { DataService } from "../data.service";
import { IntegratedAdmissionAppointment } from "src/app/model/integrated-admission/integrated-admission-appointment";
import { IntegratedOrderConf } from "src/app/model/integrated-admission/integrated-order-conf";
import { IntegratedAdmissionCreateResponse } from "src/app/model/integrated-admission/integrated-admission-create-response";

@Injectable({
  providedIn: "root",
})
export class IntegratedAdmissionService {
  constructor(
    public integratedAdmissionService: IntegratedAdmissionService,
    public dataService: DataService
  ) {}

  private readonly createEndPoint: string = "/integratedAdmission/create/";

  private readonly saveEndPoint: string = "/integratedAdmission/save/";

  private readonly getNewAdmissionEndPoint: string =
    "/integratedAdmission/getNewAdmission/";

  private readonly getIntegratedAdmissionOrderConfEndPoint: string =
    "/integratedAdmission/getIntegratedAdmissionOrderConf/";

  private readonly getNewRegularAdmissionEndPoint: string =
    "/integratedAdmission/getNewRegularAdmission/";

  private readonly getMedicalAppointmentIdsByAtentionEndPoint: string =
    "/integratedAdmission/getMedicalAppointmentIdsByAtention/";

  private readonly getControlAdmissionsEndPoint: string =
    "/integratedAdmission/getControlAdmissions/";

    private readonly medicalAppointmentWaitIntegratedAdmisionEndPoint: string =
    "/integratedAdmission/medicalAppointmentWaitIntegratedAdmision/";


  async medicalAppointmentWaitIntegratedAdmision(
    appointment: IntegratedAdmissionAppointment,
    medicalAppointmentWaitId: number
  ): Promise<IntegratedAdmissionAppointment> {
    const params = {
      Appointment: appointment,
      MedicalAppointmentWaitId: medicalAppointmentWaitId,
    };
    return await this.dataService
      .post<IntegratedAdmissionAppointment>(this.medicalAppointmentWaitIntegratedAdmisionEndPoint, params)
      .toPromise();
  }

  async getMedicalAppointmentIdsByAtention(
    atention: string
  ): Promise<number[]> {
    const params = { atention };
    return await this.dataService
      .get<number[]>(this.getMedicalAppointmentIdsByAtentionEndPoint, params)
      .toPromise();
  }

  async save(appointments: IntegratedAdmissionAppointment[]): Promise<boolean> {
    return await this.dataService
      .post<boolean>(this.saveEndPoint, appointments)
      .toPromise();
  }

  async create(
    appointments: IntegratedAdmissionAppointment[]
  ): Promise<IntegratedAdmissionCreateResponse> {
    return await this.dataService
      .post<IntegratedAdmissionCreateResponse>(
        this.createEndPoint,
        appointments
      )
      .toPromise();
  }

  async getNewRegularAdmission(
    sectorId: number,
    appointmentId: number,
    budgetId: number
  ): Promise<IntegratedAdmissionAppointment[]> {
    const params = { sectorId, appointmentId, budgetId };
    return await this.dataService
      .get<IntegratedAdmissionAppointment[]>(
        this.getNewRegularAdmissionEndPoint,
        params
      )
      .toPromise();
  }

  async getControlAdmissions(
    sectorId: number,
    atention: string
  ): Promise<IntegratedAdmissionAppointment[]> {
    const params = { sectorId, atention };
    return await this.dataService
      .get<IntegratedAdmissionAppointment[]>(
        this.getControlAdmissionsEndPoint,
        params
      )
      .toPromise();
  }

  async getNewAdmission(
    sectorId: number,
    isPre: boolean
  ): Promise<IntegratedAdmissionAppointment> {
    const params = { sectorId, isPre };
    return await this.dataService
      .get<IntegratedAdmissionAppointment>(this.getNewAdmissionEndPoint, params)
      .toPromise();
  }

  async getIntegratedAdmissionOrderConf(
    planId: number,
    isPreAdmission: boolean
  ): Promise<IntegratedOrderConf> {
    const params = { planId, isPreAdmission };
    return await this.dataService
      .get<IntegratedOrderConf>(
        this.getIntegratedAdmissionOrderConfEndPoint,
        params
      )
      .toPromise();
  }
}
